export default "__VITE_ASSET__CWb4RkKI__"